module.exports = __webpack_public_path__ + "img/az.aed905d7.svg";